var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/lib/containedBy.ts
import { DateTime as DateTime2 } from "luxon";

// src/lib/containsTime.ts
import { DateTime } from "luxon";
var weekdayHours = ({ weekdays }, dateTime) => {
  var _a;
  return (_a = weekdays[dateTime.weekday]) != null ? _a : [];
};
var dateHours = ({ dates }, dateTime) => {
  var _a;
  return (_a = dates == null ? void 0 : dates.find(({ date }) => dateTime.set(date).hasSame(dateTime, "day"))) == null ? void 0 : _a.hours;
};
var containsTime = (hours) => (timeMs = DateTime.now().toMillis()) => {
  const dateTime = DateTime.fromMillis(timeMs).setZone(hours.zone);
  const dates = dateHours(hours, dateTime);
  const weekdays = weekdayHours(hours, dateTime);
  return (dates != null ? dates : weekdays).some(
    ({ start, end }) => dateTime.set(__spreadProps(__spreadValues({}, start), { second: 0 })) <= dateTime && dateTime < dateTime.set(__spreadProps(__spreadValues({}, end), { second: 0 }))
  );
};
var hasDateHours = (hours) => (timeMs = DateTime.now().toMillis()) => {
  const dateTime = DateTime.fromMillis(timeMs).setZone(hours.zone);
  const dates = dateHours(hours, dateTime);
  return dates !== void 0;
};

// src/lib/containedBy.ts
var containedBy = (hours) => (timeMs = DateTime2.now().toMillis()) => {
  const dateTime = DateTime2.fromMillis(timeMs).setZone(hours.zone);
  const dates = dateHours(hours, dateTime);
  const weekdays = weekdayHours(hours, dateTime);
  return (dates != null ? dates : weekdays).reduce(
    (acc, { start, end }) => acc != null ? acc : dateTime.set(__spreadProps(__spreadValues({}, start), { second: 0 })) <= dateTime && dateTime < dateTime.set(__spreadProps(__spreadValues({}, end), { second: 0 })) ? { start, end } : void 0,
    void 0
  );
};
var storeClosesAt = (hours) => (timeMs = DateTime2.now().toMillis()) => {
  const closesAt = containedBy(hours)(timeMs);
  return closesAt ? __spreadProps(__spreadValues({}, closesAt.end), { zone: hours.zone }) : void 0;
};

// src/lib/format.ts
import { DateTime as DateTime3 } from "luxon";
var format = {
  hoursMinutes: ({ hour, minute, zone }) => DateTime3.now().setZone(zone).set({ hour, minute }).toFormat("h:mma")
};

// src/lib/isProductAvailable.ts
import { DateTime as DateTime5 } from "luxon";

// src/lib/legacy.ts
import { DateTime as DateTime4 } from "luxon";

// src/lib/hasValue.ts
var hasValue = (value) => {
  if (value === null || value === void 0)
    return false;
  const _testDummy = value;
  return true;
};

// src/lib/legacy.ts
var DAY = 1440;
var _convert = (startMin, endMin, weekday) => {
  if (startMin >= endMin)
    return void 0;
  const endOfDay = weekday * DAY;
  const startOfDay = endOfDay - DAY;
  const start = startMin > startOfDay ? startMin : startOfDay;
  const end = endMin < endOfDay ? endMin : endOfDay;
  return {
    start: {
      hour: Math.floor(start % DAY / 60),
      minute: start % 60
    },
    end: {
      // Force 24, if end is past midnight
      hour: endMin < endOfDay ? Math.floor(end % DAY / 60) : 24,
      minute: end % 60
    }
  };
};
var range = (start, end, step = 1) => {
  const result = [];
  for (let i = start; i <= end; i += step)
    result.push(i);
  return result;
};
var fromLegacy = ({
  local,
  special,
  zone
}) => {
  const weekdays = local.reduce((acc, { start, end }) => {
    var _a;
    const days = range(
      Math.floor(start / DAY) + 1,
      Math.floor(end / DAY) + 1
    );
    for (const day of days) {
      acc[day] = [...(_a = acc[day]) != null ? _a : [], _convert(start, end, day)].filter(
        Boolean
      );
    }
    return acc;
  }, {});
  const dates = Array.isArray(special) ? special.map(({ date, start, end }) => {
    const { year, month, day, weekday } = typeof date === "string" ? DateTime4.fromISO(date) : DateTime4.fromJSDate(date, {
      zone
    });
    return {
      date: {
        year,
        month,
        day
      },
      hours: [_convert(start, end, weekday)].filter(Boolean)
    };
  }) : void 0;
  return {
    zone,
    weekdays,
    dates
  };
};
var toLegacy = (hours) => {
  var _a;
  const zone = hours.zone;
  const local = Object.entries(hours.weekdays).flatMap(
    ([day, ranges]) => ranges.map(
      ({ start, end }) => ({
        start: (parseInt(day) - 1) * DAY + start.hour * 60 + start.minute,
        end: (parseInt(day) - 1) * DAY + end.hour * 60 + end.minute
      })
    )
  );
  const special = (_a = hours.dates) == null ? void 0 : _a.map(
    ({
      date: { year, month, day },
      hours: hours2
    }) => {
      const _date = DateTime4.fromObject(
        {
          year,
          month,
          day
        },
        { zone }
      );
      const date = _date.toJSDate();
      const weekday = _date.weekday;
      const days = DAY * (weekday - 1);
      const start = days + (hours2[0] ? hours2[0].start.hour * 60 + hours2[0].start.minute : 0);
      const end = days + (hours2[0] ? hours2[0].end.hour * 60 + hours2[0].end.minute : 0);
      return { date, start, end };
    }
  ).filter(hasValue);
  return {
    zone: hours.zone,
    local,
    special
  };
};
var splitHoursOnDays = (hour, zone) => toLegacy(
  fromLegacy({
    local: [hour],
    zone
  })
).local;

// src/lib/isProductAvailable.ts
var isProductAvailable = (hours) => (timeMs = DateTime5.now().toMillis()) => containsTime(fromLegacy(hours))(timeMs);

// src/lib/isPromotionActive.ts
import { DateTime as DateTime6 } from "luxon";
var isPromotionActive = (hours) => (timeMs = DateTime6.now().toMillis()) => containsTime(fromLegacy(hours))(timeMs);

// src/lib/isSpecialDate.ts
import { DateTime as DateTime7 } from "luxon";
var isSpecialDate = (hours) => (timeMs = DateTime7.now().toMillis()) => hasDateHours(fromLegacy(hours))(timeMs);

// src/lib/isStoreOpen.ts
import { DateTime as DateTime8 } from "luxon";
var isStoreOpen = (hours) => (timeMs = DateTime8.now().toMillis()) => containsTime(fromLegacy(hours))(timeMs);
var isStoreOpenForDelivery = (storeHours, deliveryHours) => (timeMs = DateTime8.now().toMillis()) => containsTime(fromLegacy(deliveryHours || storeHours))(timeMs);

// src/types.ts
import { z } from "zod";
var TimeOfDaySchema = z.object({
  /** The hour part (0-23) */
  hour: z.number().int().min(0).max(23),
  /** The minute part (0-59) */
  minute: z.number().int().min(0).max(59)
});
var TimeOfDayWithZoneSchema = TimeOfDaySchema.extend({
  /** The Store's IANA zone code (e.g. America/New_York) */
  zone: z.string()
});
var TimeOfDayRangeSchema = z.object({
  /** Start of range (inclusive) */
  start: TimeOfDaySchema,
  /** End of range (exclusive) */
  end: TimeOfDaySchema
});
var WeekdayTimeRangesSchema = z.record(
  z.union([
    z.literal(1),
    z.literal(2),
    z.literal(3),
    z.literal(4),
    z.literal(5),
    z.literal(6),
    z.literal(7)
  ]),
  TimeOfDayRangeSchema.array()
);
var DateSchema = z.object({
  /** The year part */
  year: z.number().int().min(2e3).max(2100),
  /** The month part (1-12) */
  month: z.number().int().min(1).max(12),
  /** The day part (1-31) */
  day: z.number().int().min(1).max(31)
});
var DatedTimesOfDaySchema = z.object({
  date: DateSchema,
  hours: TimeOfDayRangeSchema.array()
});
var LocalHoursSchema = z.object({
  /** The Store's IANA zone code (e.g. America/New_York) */
  zone: z.string(),
  /** The Store's regular hours, by weekday (1-7, Mon-Sun) */
  weekdays: WeekdayTimeRangesSchema,
  /** The Store's special hours, by date */
  dates: DatedTimesOfDaySchema.array().optional()
});
export {
  DateSchema,
  DatedTimesOfDaySchema,
  LocalHoursSchema,
  TimeOfDayRangeSchema,
  TimeOfDaySchema,
  TimeOfDayWithZoneSchema,
  WeekdayTimeRangesSchema,
  containedBy,
  containsTime,
  format,
  fromLegacy,
  hasDateHours,
  isProductAvailable,
  isPromotionActive,
  isSpecialDate,
  isStoreOpen,
  isStoreOpenForDelivery,
  splitHoursOnDays,
  storeClosesAt,
  toLegacy
};
//# sourceMappingURL=index.mjs.map